<template>
  <div class="page home">
    <!-- <footerBox></footerBox> -->
  </div>
</template>

<script>
// import footerBox from '../components/footerBox.vue'
export default {
  components: {
    // footerBox
  },
  data() {
    return {}
  },
}
</script>

<style scoped></style>
